<template>
  <div class="manage-role-dialog">
    <el-dialog
      :model-value="visible"
      align-center
      :before-close="close"
      :show-close="false"
      width="480"
    >
      <template #header>
        <h4>
          提示
        </h4>
      </template>

      <el-form
        ref="formRef"
        require-asterisk-position="right"
        class="add-platform-users-form"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <div class="mb-4 text-[var(--color-text-primary)]">
          确认要删除 [{{ row.deptName }}] 吗？
        </div>
        <el-form-item
          v-if="!isEmpty"
          v-loading="loading"
          label="转移此部门员工到其他部门"
          prop="transferId"
        >
          <el-tree-select
            v-model="form.transferId"
            :data="deptList"
            check-strictly
            default-expand-all
            :render-after-expand="false"
            :props="{
              label: 'deptName',
              value: 'id',
            }"
          />
        </el-form-item>
      </el-form>
      <div class="flex justify-end">
        <el-button :loading="saveBtnLoading" @click="close">
          取消
        </el-button>
        <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { computed, PropType, ref, watch } from 'vue';
import { IDeptTreeItem } from '@core/main/types';
import { deptTreeListDelete, queryDeptIdentityList, queryDeptTreeList } from '@core/main';
import { isNull } from '@core/tools';
const emit = defineEmits(['close', 'success']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
 
  row: {
    type: Object as PropType<IDeptTreeItem>,
    default() {
      return {} as IDeptTreeItem;
    },
  },
});

const saveBtnLoading = ref(false);
const loading = ref(false);
const formRef = ref<FormInstance>();
const form = ref({ transferId: undefined } as {transferId: number});
const deptList = ref<IDeptTreeItem[]>([]);
const identityList = ref<any[]>([]);
const formRules = ref<FormRules<{transferId: string}>>({
  transferId: [
    {
      required: true,
      message: '请选择部门名称',
    },
  ],
});

const rowId = computed(() => props.row?.id);
const isEmpty = computed(() => identityList.value?.length === 0 || isNull(identityList.value));

async function doSubmit() {
  saveBtnLoading.value = true;
  try {
    await deptTreeListDelete(rowId.value, isEmpty.value ? undefined : form.value.transferId);
    ElMessage.success('删除成功');
    close();
    emit('success');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveBtnLoading.value = false;
}

function handleSubmit() {
  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

function close() {
  formRef.value.resetFields();
  emit('close');
}

async function getDepartmentList() {
  loading.value = true;
  try {
    deptList.value = await queryDeptTreeList();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

async function getDepartmentIdentityList() {
  try {
    identityList.value = await queryDeptIdentityList(rowId.value);

    if (!isEmpty.value) {
      getDepartmentList();
    }
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

watch(
  () => props.visible,
  () => {
    if (props.visible) getDepartmentIdentityList();
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.manage-role-dialog {
  :deep(.el-dialog) {
    padding: 0;

    .el-dialog__header {
      padding: 16px 24px 8px;

      h4 {
        color: #344767;
        font-size: 20px;
        font-weight: 600;
      }

      .el-dialog__headerbtn {
        top: 5px;
      }
    }

    .el-dialog__body {
      padding: 24px 24px 16px;

      .el-form-item {
        &:last-child {
          margin-bottom: 32px;
        }

        .el-form-item__label {
          color: #6B7891;
        }

        label::before {
          margin: 0 !important;
          content: '' !important;
        }
      }
    }

  }

}
</style>
